import React, { useState, useEffect } from 'react'
import { MultiSelectCombobox } from '../../legacy-design-system/combobox'
import { Checkbox } from '../../legacy-design-system/checkbox'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { ContrastFormattedMessage } from '../contrast-formatted-message'

interface LicenseData {
  readonly license_name?: string
}

interface OnUpdate {
  readonly values: LicenseData[]
  readonly selected: boolean
}

export interface LicensePolicyProps {
  readonly onUpdate: (onUpdate: OnUpdate) => void
  readonly items: AvailableLicense[]
  readonly values: LicenseData[]
}

interface AvailableLicense {
  readonly identifier: string
  readonly fullName: string
}

export const LicensePolicyForm: React.FC<LicensePolicyProps> = ({
  onUpdate,
  items,
  values
}) => {
  const [checked, setChecked] = useState(values.length ? true : false)
  const [selectedLicenses, setSelectedLicenses] = useState(
    values.map((value) => value.license_name)
  )

  useEffect(() => {
    onUpdate({
      selected: checked,
      values: selectedLicenses.map((license) => {
        if (license) {
          const name = !license.includes('-')
            ? items.find((item) => item.fullName === license)
            : items.find((item) => license.includes(item.fullName))

          return {
            license_name: name ? name.fullName : undefined
          }
        } else {
          return {
            license_name: undefined
          }
        }
      })
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLicenses, checked])

  const formatName = ({ fullName, identifier }: AvailableLicense) => {
    if (fullName.includes(identifier)) {
      return fullName
    }
    return identifier + ' - ' + fullName
  }

  return (
    <div
      className={css`
        padding-left: 5px;
        line-height: 13px;
        padding-bottom: 10px;
        margin-bottom: 0;
      `}
    >
      <ContrastFormattedMessage id="detail_restrictLicenses">
        {(text) => (
          <Checkbox
            onChange={() => setChecked(!checked)}
            value={checked}
            label={text}
            data-testid={licensePolicyFormCheckboxId}
          />
        )}
      </ContrastFormattedMessage>

      <div
        className={css`
          padding-left: 26px;
          line-height: 13px;
          padding-bottom: 10px;
          margin-bottom: 0;
        `}
      >
        {checked ? (
          <ContrastFormattedMessage id="placeholder_findLicense">
            {(text) => (
              <MultiSelectCombobox
                values={selectedLicenses}
                label=""
                items={[
                  {
                    items: items.map((item) => formatName(item))
                  }
                ]}
                renderLabel={() => undefined}
                placeHolderText={text}
                onChange={(value) => setSelectedLicenses(value)}
              />
            )}
          </ContrastFormattedMessage>
        ) : (
          <FormattedMessage
            id="detail_disallowApplicationsUseLicenses"
            children={(msg) => (
              <span
                className={css`
                  color: #999;
                `}
              >
                {msg}
              </span>
            )}
          />
        )}
      </div>
    </div>
  )
}

export const licensePolicyFormCheckboxId = 'license-policy-form-checkbox'
